import {Address} from "./address.model";
import {CompanyLegalFormEnum} from "../enums/company-legal-form.enum";
import {Group} from "./group.model";
import {SectorIndustryEnum} from "../enums/sector-industry.enum";
import {DemasyOrganisationStatusEnum} from "../enums/demasy-organisation-status.enum";

export class Company {
  id: number;
  name: string;
  legalForm: CompanyLegalFormEnum;
  group: Group;
  industries: SectorIndustryEnum[];
  address: Address;
  demasyOrganisationId: number | null;
  demasyOrganisationName: string | null;
  demasyOrganisationStatus: DemasyOrganisationStatusEnum;


  constructor(id: number, name: string, legalForm: CompanyLegalFormEnum, group: Group, industries: SectorIndustryEnum[],
              address: Address, demasyOrganisationId: number | null, demasyOrganisationName: string | null,
              demasyOrganisationStatus: DemasyOrganisationStatusEnum) {
    this.id = id;
    this.name = name;
    this.legalForm = legalForm;
    this.group = group;
    this.industries = industries;
    this.address = address;
    this.demasyOrganisationId = demasyOrganisationId;
    this.demasyOrganisationName = demasyOrganisationName;
    this.demasyOrganisationStatus = demasyOrganisationStatus;
  }
}
